<template>
  <div>
     <v-row>
          <v-col cols="12" lg="3">
            <p class="subtitle-2 grey--text text--darken-1 mb-0 mt-3" v-text="data.text"></p>
            <p class="text-caption mb-2 grey--text text--darken-1" v-text="data.placeholder"></p>
          </v-col>
          <v-col cols="12" lg="4" class="d-flex align-center">
            <v-btn small class="text-capitalize" :id="`colorpickerActivator${data.name}`">
              <span class="mr-2">Seçili:</span>
              <v-chip label small :color="currentColor" class="px-6"></v-chip>
            </v-btn>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-divider></v-divider>
          </v-col>
        </v-row>
    <v-menu :close-on-content-click="false" :activator="`#colorpickerActivator${data.name}`">
      <div v-if="data.class === 'colorpicker'">
        <v-color-picker
          v-model="data.value"
          hide-inputs
          hide-mode-switch
          dot-size="15"
          swatches-max-height="200"
        ></v-color-picker>
      </div>
      <div v-else-if="data.class === 'rgba'">
        <v-color-picker v-model="data.value" mode="rgba" dot-size="15" swatches-max-height="200"></v-color-picker>
      </div>
      <div v-else-if="data.class === 'hexa'">
        <v-color-picker v-model="data.value" mode="hexa" dot-size="15" swatches-max-height="200"></v-color-picker>
      </div>
      <div v-else-if="data.class === 'hsla'">
        <v-color-picker v-model="data.value" mode="hsla" dot-size="15" swatches-max-height="200"></v-color-picker>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "ColorPicker",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({}),
  computed: {
    currentColor() {
      return this.data.value.hexa;
    }
  }
};
</script>

<style>
</style>